<template>
    <main class="page">
        <section class="section page__header">
            <div class="page__row">
                <div class="page__item">
                    <h1 class="title">Стадии договора</h1>
                </div>
            </div>
        </section>

        <section class="section page__content">
            <div class="page__row page__row_between mb-40">
                <div class="page__row">
                    <div class="page__item user-list__search page__search">
                        <SearchForm
                            :value="searchValue"
                            @form-submit="setSearchValue"
                        />
                    </div>
                </div>
                <div class="page__item">
                    <div class="page__row" v-if="roleAccessRemove">
                      <transition name="fade" >
                        <div class="page__item" v-if="isActiveDelete" >
                          <AppButtonSmRemove title="Удалить" @click.stop.native="showRemoveConfirmationGroup" />
                        </div>
                      </transition>
                      <div class="page__item" v-if="roleAccessCreate">
                          <AppButtonSmAdd
                              title="Создать"
                              @click.native="showModal(null)"
                          />
                      </div>
                  </div>
                </div>
            </div>
            <div class="page__row mb-20" v-if="stages.length !== 0">
                <AppTable
                    :data="stages"
                    :headers="tableHeader"
                    :has-checkbox="roleAccessEdit"
                    :isMenuControlsActive=false
                    :isSpecial="true"
                    :all-items-active="tableHeader.allActive"
                    @toggle-active-item="toggleActiveItem"
                    @toggle-active-all="toggleActiveAll"
                    @edit-this-item="showModal"
                    @show-this-item="showModal"
                    @save-item-info="saveContractStageItem"
                    @remove-this-item="showRemoveConfirmation"
                />
            </div>
            <div class="page__row mb-20" v-else>
                <div class="no-records">
                    <AppNoRecordsPlaceholder text="Записи не найдены" />
                </div>
            </div>
        </section>

        <section class="section page__footer user-list__footer">
            <div class="page__row" v-if="pagination.lastPage > 1">
              <VPagination
                :pageList="pagination.pageList"
                :currentPage="pagination.currentPage"
                @get-page="getPage"
              />
            </div>
        </section>

        <transition name="fade">
            <AppConfirmation
              v-if="removeConfirmation.active && roleAccessRemove"
              :text="removeConfirmation.group ? 'Вы действительно хотите удалить эти стадии?' : 'Вы действительно хотите удалить эту стадию?'"
              @confirm="removeConfirmation.group ? deleteContractsStageChecked() : removeStage()"
              @reject="closeRemoveConfirmation"
            />
            <ContractStageModal
                v-if="modal.active && roleAccessEdit"
                :state="modal"
                @set-item-name="setContractStageItemName"
                @set-item-color="setContractStageItemColor"
                @clear-validation="clearModalValidation"
                @save-item-info="saveContractStageItem"
                @close-modal="closeModal"
            />
            <AppModal v-if="deleteResponseModal.isActive && !deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                      :title="deleteResponseModal.title"
                      :text="deleteResponseModal.text"
                      confirmButtonTitle="Ок"
                      :confirmButtonType="deleteResponseModal.type"
                      @confirm="closeDeleteModal"
            />
            <AppModal v-if="deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                      :title="deleteResponseModalWithTreaties.title"
                      :text="deleteResponseModalWithTreaties.text"
                      confirmButtonTitle="Ок"
                      :confirmButtonType="deleteResponseModalWithTreaties.type"
                      @confirm="closeDeleteModalWithTreaties"
            />
        </transition>
        <ThePagePreloader v-if="isLoading" />
    </main>
</template>

<script>
import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import ContractStageModal from '@/components/contract/ContractStageModal'
import AppModal from '@/components/page/modal/AppModal'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import VPagination from '@/components/page/VPagination'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractStage',
  components: {
    ContractStageModal,
    ThePagePreloader,
    AppConfirmation,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmAdd,
    SearchForm,
    AppModal,
    AppButtonSmRemove,
    VPagination
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        group: false
      }
    }
  },
  computed: {
    ...mapGetters('contractStageListPage', [
      'getContractsStageListModal',
      'getContractsStageListTableHeaders',
      'getContractsStageList',
      'getContractsStageListSearchValue',
      'getContractsStageListFilter',
      'getContractsStageListPagination',
      'contractStageListIsLoading',
      'getContractsStageListResponseModal',
      'getContractsStageListResponseModalWithTreaties',
      'getContractsStageListActiveDelete'
    ]),

    modal () {
      return this.getContractsStageListModal
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    tableHeader () {
      return this.getContractsStageListTableHeaders
    },
    stages () {
      return this.getContractsStageList.map((stage) => {
        return {
          id: stage.id,
          isActive: stage.isActive,
          values: [{ data: stage.name }, { data: stage.color, mod: 'colorCell' }]
        }
      })
    },
    searchValue () {
      return this.getContractsStageListSearchValue
    },
    filter () {
      return this.getContractsStageListFilter
    },
    pagination () {
      return this.getContractsStageListPagination
    },
    isLoading () {
      return this.contractStageListIsLoading
    },
    deleteResponseModal () {
      return this.getContractsStageListResponseModal
    },
    deleteResponseModalWithTreaties () {
      return this.getContractsStageListResponseModalWithTreaties
    },
    isActiveDelete () {
      return this.getContractsStageListActiveDelete
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightContracts.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContracts.actions.remove
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightContracts.actions.update
    }
  },
  methods: {
    toggleItemControls (itemId) {
      this.$store.dispatch(
        'contractStageListPage/toggleContractsStageListItemControls',
        itemId
      )
    },
    toggleActiveItem (itemId) {
      this.$store.dispatch('contractStageListPage/toggleContractsStageListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('contractStageListPage/toggleContractsStageListItemActiveAll')
    },
    showModal (itemId) {
      this.$store.dispatch('contractStageListPage/showContractsStageModal', itemId)
    },
    setContractStageItemName (value) {
      this.$store.dispatch('contractStageListPage/setContractsStageItemName', value)
    },
    setContractStageItemColor (value) {
      this.$store.dispatch('contractStageListPage/setContractsStageItemColor', value)
    },
    clearModalValidation (inputName) {
      this.$store.dispatch(
        'contractStageListPage/clearContractsStageModalValidation',
        inputName
      )
    },
    saveContractStageItem (itemId) {
      this.$store.dispatch('contractStageListPage/saveContractsStageItem', itemId)
    },
    closeModal () {
      this.$store.dispatch('contractStageListPage/closeContractsStageModal')
    },
    showRemoveConfirmation (id) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = id
    },
    removeStage () {
      const itemId = this.removeConfirmation.id
      this.$store.dispatch('contractStageListPage/removeContractsStage', itemId)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    deleteContractsStageChecked () {
      this.removeConfirmation.active = false
      this.$store.dispatch('contractStageListPage/deleteContractsStageListCheckedItems')
      this.removeConfirmation.group = false
    },
    closeDeleteModal () {
      this.$store.dispatch('contractStageListPage/closeContractsStageListDeleteModal')
    },
    closeDeleteModalWithTreaties () {
      this.$store.dispatch('contractStageListPage/closeContractsStageListDeleteModalWithTreaties')
    },

    // search
    setSearchValue (value) {
      this.$store.dispatch('contractStageListPage/setContractsStageListSearchValue', value)
    },

    // filter

    // pagination
    getPage (pageNum) {
      this.$store.dispatch('contractStageListPage/getContractsStageListPage', pageNum)
    }
  },
  mounted () {
    this.$store.dispatch('contractStageListPage/getContractsStage')
  },

  destroyed () {
    this.$store.commit('contractStageListPage/RESET_CONTRACTS_STAGE_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
.no-records {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  display: flex;
}
</style>
